import * as echarts from 'echarts/core';
import { useMemo } from 'react';
import styles from './index.module.scss';
import { GridComponent, GridComponentOption } from 'echarts/components';
import { BarChart, BarSeriesOption } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import deliveryTruck from '../../assets/deliveryTruck.svg';
import industryProduce from '../../assets/industryProduce.svg';
import rawMaterial from '../../assets/rawMaterial.svg';
import { EchartsWithTheme, Themes, useTheme } from '@maxtropy/components';
interface BarEchartsProps {
  carbonData?: any;
}
type EChartsOption = echarts.ComposeOption<GridComponentOption | BarSeriesOption>;

echarts.use([GridComponent, BarChart, CanvasRenderer]);
const BarEcharts: React.FC<BarEchartsProps> = ({ carbonData }) => {
  const theme = useTheme();

  const option: EChartsOption = useMemo(() => {
    return {
      title: [
        {
          text: '生命周期各阶段碳足迹',
          subtext: '',
          left: '-6px',
          top: '8px',
          textStyle: {
            color: theme === Themes.DARK ? 'rgba(255,255,255,0.85)' : 'rgba(0,0,0,0.85)',
            fontWeight: 500,
            fontSize: 16,
          },
        },
        {
          text: '',
          subtext: '（单位：kgCO2e）',
          left: '150px',
          subtextStyle: {
            color: theme === Themes.DARK ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,0.65)',
            fontWeight: 500,
            fontSize: 14,
          },
        },
      ],
      grid: {
        left: '2%',
        right: '4%',
        containLabel: true,
      },
      tooltip: null,
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01],
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        splitLine: {
          show: false,
        },
      },
      yAxis: {
        type: 'category',
        data: ['生产', '原料运输', '原料获取'],
        axisLabel: {
          align: 'left',
          margin: 80,
          verticalAlign: 'middle',
        },
        splitLine: {
          show: false,
        },
      },
      series: [
        {
          itemStyle: {
            color: {
              type: 'linear',
              x: 1,
              y: 0,
              x2: 0,
              y2: 0, // 设置渐变的起始和结束点坐标（范围为 0 到 1）
              colorStops: [
                { offset: 0, color: '#23E994' }, // 渐变起始颜色
                { offset: 1, color: '#6DEA43' }, // 渐变结束颜色
              ],
              global: false, // 缺省为 false
            },
          },
          type: 'bar',
          data: carbonData,
          barWidth: '33%',
          label: {
            show: true,
            position: 'right',
          },
        },
      ],
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carbonData]);

  return (
    <div className={styles.content}>
      <img src={rawMaterial} alt="" className={styles.rawMaterial} />
      <img src={deliveryTruck} alt="" className={styles.deliveryTruck} />
      <img src={industryProduce} alt="" className={styles.industryProduce} />
      <EchartsWithTheme
        option={option}
        style={{ height: '286px', width: '100%', position: 'relative' }}
        theme={theme}
        params={{ dataZoomExit: false }}
      />
    </div>
  );
};

export default BarEcharts;
